const React = require('react');
const { useTranslation } = require('react-i18next');
require('./Spinner.css');

// Figma spinner: a three-quarter ring that steps 90° every 200ms (4 frames).
// Smart-animate between the frames is a smooth 360° every 4 * 200ms = 800ms,
// so we render one arc and rotate it in CSS instead of flip-booking 8 SVGs.
// Arc geometry is the Figma "step=1" frame (24px viewBox; scales to any size).
const ARC_PATH =
  'M13.9077 6.31136C12.7155 5.91156 11.4279 5.89641 10.2266 6.26806C9.02536 6.63972 7.97123 7.37938 7.21312 8.38258C6.45501 9.38577 6.03123 10.6018 6.00166 11.8589C5.97209 13.116 6.3382 14.3506 7.0483 15.3883C7.7584 16.4261 8.77658 17.2145 9.95903 17.6422C11.1415 18.0699 12.4284 18.1154 13.6381 17.7721L15.2762 23.5441C12.8568 24.2307 10.2829 24.1399 7.91805 23.2844C5.55316 22.4289 3.51679 20.8521 2.0966 18.7766C0.676409 16.7011 -0.0558274 14.2319 0.003321 11.7178C0.0624694 9.2036 0.910013 6.77155 2.42624 4.76515C3.94246 2.75876 6.05072 1.27943 8.45323 0.536126C10.8557 -0.207178 13.4311 -0.176889 15.8154 0.622716C18.1998 1.42232 20.2727 2.95083 21.7413 4.99233C23.2099 7.03383 24 9.48514 24 12H18C18 10.7426 17.6049 9.51691 16.8706 8.49616C16.1363 7.47541 15.0999 6.71116 13.9077 6.31136Z';

// Matches the Figma variants: small = 16px, medium = 24px.
const SPINNER_SIZES = { small: 16, medium: 24 };

/**
 * n-drip loading spinner (rotating three-quarter ring, --color-grey-71).
 *
 * @param {{ size?: 'small' | 'medium', color?: string, className?: string,
 *   style?: object }} props
 *   - size: 16px ('small') or 24px ('medium', default)
 *   - color: overrides the ring color (defaults to --color-grey-71 via CSS)
 *   - style: merged onto the wrapper (e.g. for margins / alignment)
 */
const Spinner = ({ size = 'medium', color, className = '', style }) => {
  const { t } = useTranslation();
  const px = SPINNER_SIZES[size] ?? SPINNER_SIZES.medium;

  return (
    <span
      className={`ndrip-spinner ${className}`.trim()}
      role='status'
      style={color ? { color, ...style } : style}
    >
      <svg
        width={px}
        height={px}
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d={ARC_PATH}
          fill='currentColor'
        />
      </svg>
      <span className='sr-only'>{t('loading')}</span>
    </span>
  );
};

module.exports = Spinner;
